@for (card of statsCards(); track card.id; let i = $index) {
  <app-stats-summary-card [data]="card" [index]="i" [total]="statsCards().length" />
}
